import { iStore } from "../../store.model";

export const selectHQAccessToken = (state: iStore) => {
  return state.hq.HQAccessToken;
};
